module.exports = __webpack_public_path__ + "media/svg-new/rightArrow-751f0fdc.svg";